import React from "@platform/react";
import { getClassName } from "@platform/react-storybook/Component";

import { Card } from "..";

import Rules from "./_rules.module.scss";
import { DEF_HORIZONTAL_CARD } from "./types";
import type { PropTypesHorizontalCard } from "./types";

/** Shows a HorizontalCard for categorizing */
export function HorizontalCard(props: PropTypesHorizontalCard) {
    const { bitmap, href, pills = [], title, summary, ...rest } = props;
    const className = getClassName(Rules.root, rest.className);

    return (
        <Card
            {...rest}
            hasFade
            bitmap={bitmap}
            className={className}
            footer={({ Summary }) => <Summary preset="large" summary={summary} title={title} />}
            header={({ Pill }) => pills.map((pill) => <Pill key={pill} text={pill} />)}
            href={href}
        />
    );
}
HorizontalCard.defaultProps = DEF_HORIZONTAL_CARD;
